import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Icon} from '@iconify/react';
import './About.css';

const About=()=>{
    const navigate = useNavigate();

    const openSocial=(platform)=>{
        const map = {
            twitter:'https://twitter.com/aipredict__',
            instagram:'https://instagram.com/aipredict__',
            telegram:'https://t.me/+hSDOOOwDkAEwMzdk'
        };

        const url = map[platform] || 'https://twitter.com/aipredict__';
        window.open(url,'_blank','noopener,noreferrer');
    };

    return(
        <section className="about">
            <div className="about__bg-glow about__bg-glow--one" />
            <div className="about__bg-glow about__bg-glow--two" />
            <div className="about__grid" />

            <div className="about__inner">
                <div className="about__top">
                    <div className="about__eyebrow">
                        <span className="about__dot" />
                        <span>About AiPredict</span>
                    </div>

                    <h1 className="about__title">Football predictions. Crypto trading. One platform.</h1>

                    <p className="about__subtitle">
                        AiPredict is where AI-powered football analysis meets automated crypto trading. 
                        Get match predictions you can trust, or let Ignis trade your Bybit account 
                        while you sleep — all in a clean interface with transparent pricing.
                    </p>

                    <div className="about__cta-row">
                        <button className="about__btn about__btn--primary" onClick={()=>navigate('/crypto')}>
                            Ignis AI Agent
                        </button>
                        <button className="about__btn about__btn--ghost" onClick={()=>navigate('/ai-assistant')}>
                            Try AiAssistant
                        </button>
                    </div>
                </div>

                {/* CARDS */}
                <div className="about__cards">
                    <div className="about__card">
                        <div className="about__card-top">
                            <div className="about__icon">
                                <Icon icon="solar:football-outline" width="20" height="20" />
                            </div>
                            <div className="about__card-title">Football Predictions</div>
                        </div>
                        <div className="about__card-text">
                            Our V10 and HRHR engines analyze matches in real-time — form, injuries, head-to-head, 
                            and value — so you get structured picks instead of guesswork. Premium users get 
                            access to both engines with higher daily limits.
                        </div>
                        <div className="about__pill-row">
                            <span className="about__pill">V10 Engine</span>
                            <span className="about__pill">HRHR Value Picks</span>
                            <span className="about__pill">Premium Unlocks</span>
                        </div>
                    </div>

                    <div className="about__card">
                        <div className="about__card-top">
                            <div className="about__icon">
                                <Icon icon="solar:chart-2-outline" width="20" height="20" />
                            </div>
                            <div className="about__card-title">Ignis AI Agent</div>
                        </div>
                        <div className="about__card-text">
                            Connect your Bybit account and let our AI trade for you. Multiple engines powered by 
                            trend detection and proprietary indicators run 24/7, placing trades with built-in 
                            stop-losses and tiered take-profits. You keep full control of your funds.
                        </div>
                        <div className="about__pill-row">
                            <span className="about__pill">AI Agent Trading</span>
                            <span className="about__pill">3 Tiers</span>
                            <span className="about__pill">Bybit & Binance API</span>
                        </div>
                    </div>

                    <div className="about__card">
                        <div className="about__card-top">
                            <div className="about__icon">
                                <Icon icon="solar:chat-round-dots-outline" width="20" height="20" />
                            </div>
                            <div className="about__card-title">AiAssistant</div>
                        </div>
                        <div className="about__card-text">
                            Need a quick take on tonight's fixtures? The AiAssistant gives you match 
                            analysis on demand. Ask about any game and get a structured breakdown with 
                            reasoning — not just a scoreline.
                        </div>
                        <div className="about__pill-row">
                            <span className="about__pill">On-Demand Analysis</span>
                            <span className="about__pill">Usage Limits</span>
                            <span className="about__pill">Premium Boosts</span>
                        </div>
                    </div>
                </div>

                {/* HOW IT WORKS */}
                <div className="about__section">
                    <div className="about__section-head">
                        <h2 className="about__h2">How AiPredict works</h2>
                        <p className="about__p">
                            Whether you're here for football predictions or automated crypto trading, the flow is simple.
                        </p>
                    </div>

                    <div className="about__steps">
                        <div className="about__step">
                            <div className="about__step-n">01</div>
                            <div className="about__step-body">
                                <div className="about__step-title">Pick your lane</div>
                                <div className="about__step-text">
                                    Football predictions, Ignis AI Agent, or the AiAssistant — each feature has its own dedicated screen. No clutter.
                                </div>
                            </div>
                        </div>

                        <div className="about__step">
                            <div className="about__step-n">02</div>
                            <div className="about__step-body">
                                <div className="about__step-title">Connect or analyze</div>
                                <div className="about__step-text">
                                    For football, enter your fixtures and get AI analysis. For crypto, connect your Bybit & Binance API and Ignis starts trading for you automatically.
                                </div>
                            </div>
                        </div>

                        <div className="about__step">
                            <div className="about__step-n">03</div>
                            <div className="about__step-body">
                                <div className="about__step-title">Track everything live</div>
                                <div className="about__step-text">
                                    See Ignis's open positions, P&L, and trade history in real-time. Football predictions come with clear reasoning so you know why, not just what.
                                </div>
                            </div>
                        </div>

                        <div className="about__step">
                            <div className="about__step-n">04</div>
                            <div className="about__step-body">
                                <div className="about__step-title">Scale when ready</div>
                                <div className="about__step-text">
                                    Start free for football, or pick an Ignis tier that fits your capital. Upgrade anytime — Bronze, Silver, or Gold — and Ignis adjusts automatically.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about__note">
                        <Icon icon="solar:shield-check-outline" width="18" height="18" />
                        <span>
                            AiPredict is built for responsible trading and betting. Ignis uses Isolated Margin and built-in stop-losses. Always trade with capital you can afford to lose.
                        </span>
                    </div>
                </div>

                {/* CONTACT */}
                <div className="about__section">
                    <div className="about__contact">
                        <div className="about__contact-left">
                            <h2 className="about__h2" style={{marginBottom:'0.4rem'}}>Get In Touch</h2>
                            <p className="about__p" style={{marginBottom:0}}>
                                Join our Telegram for Ignis updates and trade alerts, or reach us on socials for general support and announcements.
                            </p>
                        </div>

                        <div className="about__contact-actions">
                            <button className="about__social about__social--telegram" onClick={()=>openSocial('telegram')}>
                                <Icon icon="logos:telegram" width="18" height="18" />
                                <span>Telegram</span>
                            </button>

                            <button className="about__social about__social--twitter" onClick={()=>openSocial('twitter')}>
                                <Icon icon="logos:twitter" width="18" height="18" />
                                <span>Twitter</span>
                            </button>

                            <button className="about__social about__social--instagram" onClick={()=>openSocial('instagram')}>
                                <Icon icon="skill-icons:instagram" width="18" height="18" />
                                <span>Instagram</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* FOOTER */}
                <footer className="about__footer">
                    <span>© {new Date().getFullYear()} AiPredict. All rights reserved.</span>
                    <span className="about__footer-dot">•</span>
                </footer>
            </div>
        </section>
    );
};

export default About;